// extracted by mini-css-extract-plugin
module.exports = {"dot":"StageTracker_dot__IFwFO","step":"StageTracker_step__2rIGF"};